import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Personal(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.116 12.427c2.232 0 4.287.425 6.107 1.262 3.135 1.44 4.658 3.632 4.658 6.7 0 1.405-1.192 2.548-2.658 2.548H3.659C2.193 22.937 1 21.794 1 20.39c0-3.124 1.48-5.325 4.528-6.729 1.773-.818 3.805-1.233 6.038-1.233h.549zm0 1.934h-.55c-1.95 0-3.71.354-5.228 1.055-2.354 1.085-3.404 2.62-3.404 4.973 0 .34.325.615.725.615h16.564c.4 0 .725-.276.725-.615 0-2.297-1.09-3.82-3.532-4.944-1.566-.72-3.35-1.084-5.3-1.084zM11.942 1a5.077 5.077 0 015.07 5.071 5.078 5.078 0 01-5.07 5.072A5.078 5.078 0 016.87 6.071 5.077 5.077 0 0111.94 1zm0 2A3.075 3.075 0 008.87 6.071a3.075 3.075 0 003.07 3.072 3.075 3.075 0 003.072-3.072A3.075 3.075 0 0011.942 3z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoPersonal = React.memo(Personal);
export default MemoPersonal;